export const localOffsTypes = [
	'OFF-LOCAL-PROGRAM-INTRO',
	'OFF-LOCAL-PROGRAM-OUTRO',
	'OFF-LOCAL-BLOCK-INTRO',
	'OFF-LOCAL-BLOCK-OUTRO',
	'OFF-LOCAL-BLOCK-MID',
];
